// src/utils/profileCompleteness.js
// Profile completeness check for Badge 1 verification.
// Used by: dashboard display, admin review queue, Cloud Functions.

/**
 * checkProfileCompleteness — Evaluates if a practitioner's profile meets Badge 1 requirements.
 *
 * @param {Object} practitionerData - The full practitioner document from Firestore
 * @returns {{ isComplete: boolean, details: Object }}
 *   details: { hasName, hasPhoto, hasBio, hasService, hasAvailability }
 */
export function checkProfileCompleteness(practitionerData) {
  if (!practitionerData) {
    return {
      isComplete: false,
      details: { hasName: false, hasPhoto: false, hasBio: false, hasService: false, hasAvailability: false },
    };
  }

  const profile = practitionerData.website_published?.profile
    || practitionerData.website_draft?.profile
    || practitionerData.profile
    || {};

  const services = practitionerData.website_published?.services
    || practitionerData.website_draft?.services
    || practitionerData.services
    || [];

  const details = {
    hasName: !!(
      practitionerData.displayName
      || practitionerData.name
      || profile.displayName
      || profile.name
    ),
    hasPhoto: !!(
      profile.photoUrl
      || profile.photo
      || practitionerData.photoUrl
    ),
    hasBio: !!(
      profile.bio && profile.bio.trim().length >= 20
    ),
    hasService: (
      Array.isArray(services) && services.length > 0 && services.some(s => s.active !== false)
    ),
    hasAvailability: !!(
      practitionerData.availability && Object.keys(practitionerData.availability).length > 0
    ),
  };

  const isComplete = Object.values(details).every(v => v === true);

  return { isComplete, details };
}
